// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function isApiGraphQLConfig(apiGraphQLConfig) {
    return apiGraphQLConfig !== undefined;
}

export { isApiGraphQLConfig };
//# sourceMappingURL=isApiGraphQLProviderConfig.mjs.map
